import React from 'react'
import { Box, Button } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useNavigate } from 'react-router-dom'
import { J2Caution } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import Banner from 'src/Components/banner/Banner'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners'
import { useHagerBridgePermissions } from '../hooks/use-hager-bridge-permissions'

const useStyles = makeStyles()(theme => ({
  container: {
    backgroundColor: theme.palette.warning.light,
  },
}))

interface CountryInfoMissingBannerProps {
  bannerKey: BannerKey
}

/**
 * Component for displaying banner about country info location
 */
export const CountryInfoMissingBanner: React.FC<CountryInfoMissingBannerProps> = ({ bannerKey }): JSX.Element => {
  const { t } = useCustomTranslation()
  const navigate = useNavigate()
  const { classes } = useStyles()
  const { permissions } = useHagerBridgePermissions()

  return (
    <Box mb={2}>
      <Banner
        bannerKey={bannerKey}
        i18nKey={
          permissions.countryInfoPermissions.countryInfo
            ? 'emobility.country-info.location-not-supported'
            : 'emobility.country-info.location-not-supported-regular-users'
        }
        closeType={BannerCloseTypes.Temporary}
        button={
          permissions.countryInfoPermissions.countryInfo ? (
            <Button variant="contained" color="warning" onClick={() => navigate('/contact')}>
              {t('emobility.country-info.contact-support')}
            </Button>
          ) : undefined
        }
        icon={<J2Caution color="warning" />}
        containerStyle={classes.container}
      />
    </Box>
  )
}
